import * as yup from 'yup';
import i18n from 'i18n';

export const companyInfoSchema = yup.object().shape({
  companyName: yup.string().required(() => i18n.t('website:auth.register.companyInfo.validation.companyNameRequired')),
  country: yup.string().required(() => i18n.t('website:auth.register.companyInfo.validation.countryRequired')),
  vat: yup
    .string()
    .required(() => i18n.t('website:auth.register.companyInfo.validation.vatRequired'))
    .length(10, () => i18n.t('website:auth.register.companyInfo.validation.vatLength')),
});
